import { getRequest, postRequest, patchRequest } from '../utils/axios';
import { buildUrlParams } from '../utils/urls';

export const apiTokensService = {
  listTokens: (onSuccess, onError) => {
    getRequest('/api/v1/api-tokens/', (r) => onSuccess?.(r), (e, r) => onError?.(e, r));
  },

  createToken: (data, onSuccess, onError) => {
    postRequest('/api/v1/api-tokens/', data, (r) => onSuccess?.(r), (e, r) => onError?.(e, r));
  },

  updateToken: (hash, data, onSuccess, onError) => {
    patchRequest(`/api/v1/api-tokens/${hash}/`, data, (r) => onSuccess?.(r), (e, r) => onError?.(e, r));
  },

  revokeToken: (hash, onSuccess, onError) => {
    postRequest(`/api/v1/api-tokens/${hash}/revoke/`, {}, (r) => onSuccess?.(r), (e, r) => onError?.(e, r));
  },

  playgroundSession: (hash, onSuccess, onError) => {
    postRequest(
      `/api/v1/api-tokens/${hash}/playground-session/`,
      {},
      (r) => onSuccess?.(r),
      (e, r) => onError?.(e, r),
    );
  },

  tokenUsage: (hash, params, onSuccess, onError) => {
    const url = `/api/v1/api-tokens/${hash}/usage/` + buildUrlParams(params || {});
    getRequest(url, (r) => onSuccess?.(r), (e, r) => onError?.(e, r));
  },

  listRequests: (params, onSuccess, onError) => {
    const url = '/api/v1/api-requests/' + buildUrlParams(params || {});
    getRequest(url, (r) => onSuccess?.(r), (e, r) => onError?.(e, r));
  },

  getRequest: (hash, onSuccess, onError) => {
    getRequest(`/api/v1/api-requests/${hash}/`, (r) => onSuccess?.(r), (e, r) => onError?.(e, r));
  },

  usageSummary: (params, onSuccess, onError) => {
    const url = '/api/v1/api-requests/usage/' + buildUrlParams(params || {});
    getRequest(url, (r) => onSuccess?.(r), (e, r) => onError?.(e, r));
  },
};
